module.exports = __webpack_public_path__ + "img/avatar3.9ee09aba.png";